/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WillRequestDto = {
    id: string;
    supporter_name: string;
    supporter_id: string;
    charity_name: string;
    email: string;
    phone: string;
    date_of_birth: string;
    address_line1: string;
    address_line2: string;
    city: string;
    state: string;
    postal_code: string;
    date_requested: string;
    solicitor_id: string;
    solicitor_name: string;
    /**
     * Assigned solicitor branch: firm name and branch location
     */
    solicitor_branch?: string;
    status: WillRequestDto.status;
    created_at: string;
    updated_at: string;
    notes: string;
    type: WillRequestDto.type;
    giftToCharity: boolean;
    conditionalGift: boolean;
    description: string;
    estimatedGiftValue: number;
    consentToShare: boolean;
    giftType: string;
    dateRequested: string;
    dateOfWill: string;
    willDocuments: Array<string>;
};
export namespace WillRequestDto {
    export enum status {
        NEW = 'NEW',
        ACCEPTED_BY_SOLICITOR = 'ACCEPTED_BY_SOLICITOR',
        DECLINED = 'DECLINED',
        ASSIGNED_TO_SOLICITOR = 'ASSIGNED_TO_SOLICITOR',
        WILL_COMPLETE = 'WILL_COMPLETE',
        PAYMENT_DECLINED = 'PAYMENT_DECLINED',
        REQUEST_COMPLETE = 'REQUEST_COMPLETE',
        DECLINED_BY_SOLICITOR = 'DECLINED_BY_SOLICITOR',
        DECLINED_BY_PLATFORM = 'DECLINED_BY_PLATFORM',
    }
    export enum type {
        SINGLE = 'SINGLE',
        JOINT = 'JOINT',
    }
}

